module.exports = __webpack_public_path__ + "img/chinaboy.383dec11.jpg";